import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import Footer from "@/components/Footer";
import { MzHeader } from "@/components/monetize/MzHeader";
import { MzHero } from "@/components/monetize/MzHero";
import { MzProducts } from "@/components/monetize/MzProducts";
import { MzAdvisor } from "@/components/monetize/MzAdvisor";
import { MzWorkflow } from "@/components/monetize/MzWorkflow";
import { MzGrowth } from "@/components/monetize/MzGrowth";
import { MzCompare } from "@/components/monetize/MzCompare";
import { MzFeatures } from "@/components/monetize/MzFeatures";
import { MzPricing } from "@/components/monetize/MzPricing";
import { MzFinalCta } from "@/components/monetize/MzFinalCta";

export default function MonetizeMarketingPage() {
  const { user } = useAuth();
  const [checkout, setCheckout] = useState(null);
  const [annual, setAnnual] = useState(false);

  useEffect(() => {
    api.get("/monetize/checkout")
      .then((r) => setCheckout(r.data))
      .catch(() => setCheckout({ monthly: "", annual: "" }));
    document.title = "GoldKey Monetization Hub · Turn your audience into income";
  }, []);

  const baseUrl = annual ? checkout?.annual : checkout?.monthly;
  const url = (() => {
    if (!baseUrl) return "/contact?topic=monetize-hub";
    try {
      const u = new URL(baseUrl);
      if (user?.user_id) u.searchParams.set("client_reference_id", user.user_id);
      if (user?.email) u.searchParams.set("prefilled_email", user.email);
      return u.toString();
    } catch {
      return baseUrl;
    }
  })();

  return (
    <div className="mz-page min-h-screen">
      <MzHeader ctaHref={url} />
      <MzHero url={url} user={user} annual={annual} />
      <MzProducts />
      <MzAdvisor />
      <MzWorkflow />
      <MzGrowth />
      <MzCompare />
      <MzFeatures />
      <MzPricing annual={annual} setAnnual={setAnnual} url={url} />
      <MzFinalCta url={url} />
      <Footer />
    </div>
  );
}
